import request from "@/utils/request";

// 新增店铺信息接口
export function addAgreementPreview(obj) {
  return request({
    url: "/apis/sra/store/users/signup/preview",
    method: "post",
    data: obj,
  });
}

// 新增店铺信息接口
export function addShopByThreeParty(obj) {
  return request({
    url: "/apis/sra/store/users/signup/addShopByThreeParty",
    method: "post",
    data: obj,
  });
}

// 新增店铺信息接口
export function getAddShop(obj) {
  return request({
    url: "/apis/sra/store/users/signup/addShop",
    method: "post",
    data: obj,
  });
}

// 查询店铺信息接口
export function qryShopInfo(obj) {
  return request({
    url: "/apis/sra/store/users/signup/qryShopInfo",
    method: "post",
    data: obj
  });
}
// 销售品类名称
export function qryFirstClassify(data) {
  return request({
    url: "/apis/sra/store/users/signup/qryAllCate",
    method: "POST",
    data
  });
}
// 查询4A组织结构树（全部单位）
export function getQryOrgTree(data) {
  return request({
    url: "/apis/sra/store/users/signup/qryOrgTree",
    method: "POST",
    data: { ...data, isShowLoading: true }
  });
}

// 成员分组查询
export function queryMemberGroup(data) {
  return request({
    url: "/apis/sra/store/users/signup/queryMemberGroup",
    method: "POST",
    data
  });
}
// 成员分组查询
export function qryNonCCCCDeveloperInfo(data) {
  console.log(data,'data')
  return request({
    url: "/apis/sra/store/users/signup/qryNonCCCCDeveloperInfo",
    method: "POST",
    data
  });
}
// 经营类目全部
export function selectAllCategory(data) {
  console.log(data,'data')
  return request({
    url: "/apis/sra/spc/category/users/signup/selectAllCategory",
    method: "POST",
    data
  });
}

// 是否供应链入网
export function qrySupInfoList(data) {
  console.log(data,'data')
  return request({
    url: "/apis/sra/store/users/signup/qrySupInfoList",
    method: "POST",
    data
  });
}

// 是否供应链入网(新加的)
export function qrySupInfoListItem(data) {
  return request({
    url: "/apis/sra/smc/users/signup/qrySupInfoListItem",
    method: "POST",
    timeout: 5 * 60 * 1000,
    data
  });
}

// 检测黑名单
export function checkSupplierBlackList(data) {
  return request({
    url: "/apis/sra/store/users/signup/checkSupplierBlackList",
    method: "POST",
    data
  });
}
// 查询供应商法律风险信息
export function qrySupLegalRisk(data) {
  return request({
    url: "/apis/sra/smc/users/signup/qrySupLegalRisk",
    method: "POST",
    data
  });
}
// 查询供应商经营风险信息
export function qrySupBusinessRisk(data) {
  return request({
    url: "/apis/sra/smc/users/signup/qrySupBusinessRisk",
    method: "POST",
    data
  });
}

// 检测店铺是否已注册过
export function checkBusinessInfo(data) {
  return request({
    url: "/apis/sra/store/users/signup/checkBusinessInfo",
    method: "POST",
    data
  });
}
